// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","reseau":"Footer_reseau__q7Xx4","topFooter":"Footer_topFooter__E2XKb","logo":"Footer_logo__w79hm","ul":"Footer_ul__F7CXb","a":"Footer_a__PK+xZ"};